import { render } from "./Loader.vue?vue&type=template&id=b230e51e"
const script = {}
script.render = render

export default script